import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { width, generateId } from "../helpers";
import { useSelector } from "react-redux";

export default function Integracao(props) {
  const [activeScreen, setActiveScreen] = useState();

  const _login = useSelector((state) => state.login);

  let _integracoes = [
    {
      id: generateId(),
      title: "Integracoes a Vencer",
      description: "Clientes com integrações próximas do vencimento",
    },
    {
      id: generateId(),
      title: "Integrações Vencidas",
      description: "Clientes com integrações Vencidas",
    },
  ];

  let _documentos = [
    {
      id: generateId(),
      title: "Empresa - Próximos do Vencimento",
      description: "Documentos da Empresa próximos do vencimento",
    },
    {
      id: generateId(),
      title: "Empresa - Vencidos",
      description: "Documentos da Empresa vencidos",
    },
    {
      id: generateId(),
      title: "Funcionários - Próximos do Vencimento",
      description: "Documentos do Funcionário próximos do vencimento",
    },
    {
      id: generateId(),
      title: "Funcionários - Vencidos",
      description: "Documentos do Funcionário vencidos",
    },
  ];

  useEffect(() => {
    // console.log("Acessou componente integracao.js");
    // console.log("Integracao._login: ", _login);
  }, []);

  useEffect(() => {
    // console.log("Integracao.ActiveScreen: ", activeScreen);
  }, [activeScreen]);

  function ActiveScreen() {
    return activeScreen;
  }

  return (
    <div
      style={{
        marginTop: "5px",
        marginLeft: "5px",
        marginRight: "5px",
        marginBottom: "5px",
      }}
    >
      <Navbar activeScreen={activeScreen} setActiveScreen={setActiveScreen} />
      {activeScreen && <ActiveScreen />}
    </div>
  );
}
